(function () {
	function swiperInit() {
		subSliderInit(true);
		sliderInit(true);
		popupSliderInit(true);
	}

	function waitForSwiperAndInit() {
		if (typeof Swiper === 'undefined') {
			setTimeout(waitForSwiperAndInit, 50);
			return;
		}
		if (
			typeof sliderInit === 'undefined' ||
			typeof subSliderInit === 'undefined' ||
			typeof popupSliderInit === 'undefined'
		) {
			setTimeout(waitForSwiperAndInit, 50);
			return;
		}
		swiperInit();
	}

	document.addEventListener('shopify:section:load', function () {
		waitForSwiperAndInit();
	});

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', waitForSwiperAndInit);
	} else {
		waitForSwiperAndInit();
	}
})();
